/* istanbul ignore file */
import { InputList, InputListProps } from 'framework/form';
import PurchaseInput from 'domain/finance/purchaseOrder/shared/input/PurchaseInput';
import PurchaseListInputTotal from 'domain/finance/purchaseOrder/shared/input/PurchaseListInputTotal';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material';

const purchaseListInputSx: SxProps<Theme> = theme => ({
  position: 'relative',

  [theme.breakpoints.up('smallMobile')]: {
    '& .removable-input': {
      flexWrap: 'nowrap',
      marginBottom: '16px',

      '&:last-of-type': {
        marginBottom: '16px',
      },

      '&:not(:first-child)': {
        '& .label__wrapper': {
          display: 'none',
        },

        '& .add-info-btn': {
          marginTop: '6px',
        },
      },

      '& .form-group': {
        marginBottom: 0,
      },

      '& .add-info-btn': {
        width: 'auto',
        marginTop: '29px',
        marginLeft: '20px',
      },
    },

    '& #add': {
      marginTop: '30px',
    },
  },

  '& > div > div > div > label': {
    fontWeight: 500,
    fontSize: '16px',
    color: 'primary',
  },

  '& .MuiFormHelperText-root:not(:empty)': {
    marginBottom: '-6px',
  },
});

const PurchaseListInput = ({
  source,
  currencySource,
  ...props
}: Omit<InputListProps, 'inputTemplate' | 'addText'> & { currencySource: string }) => {
  return (
    <Box sx={purchaseListInputSx}>
      <InputList
        {...props}
        source={source}
        addText="Add purchase"
        inputTemplate={(inputProps: any) => <PurchaseInput {...inputProps} currencySource={currencySource} />}
        defaultValue={{}}
        maxFields={1000}
      />
      <PurchaseListInputTotal purchasesSource={source} currencySource={currencySource} />
    </Box>
  );
};

export default PurchaseListInput;
